import { createSelector } from "reselect";

import { EMPTY_ARRAY } from "lib";

import {
  selectEidByWeighLotScanIdLookup,
  selectWeighLotScanIdsByEidLookup,
} from "./indexes";
import {
  createLookupCombiner,
  createLookupSelectors,
  reduceXByZId,
} from "./lib";
import { getScans, getWeighLotScans } from "./root";

export const [selectScanByWeighLotScanIdLookup, getScanByWeighLotScanId] =
  createLookupSelectors(
    [getScans, selectEidByWeighLotScanIdLookup],
    reduceXByZId,
  );

export const getWeighLotScanById = weighLotScanId => state =>
  getWeighLotScans(state)[weighLotScanId] || null;

export const getWeighLotScanIdsByEid = eid => state =>
  selectWeighLotScanIdsByEidLookup(state)[eid] || EMPTY_ARRAY;

export const selectReceivalLotIdByWeighLotScanId = createSelector(
  [getWeighLotScans, selectScanByWeighLotScanIdLookup],
  createLookupCombiner((weighLotScan, scanByWeighLotScanIdLookup) => {
    const scan = scanByWeighLotScanIdLookup[weighLotScan.id] || {};
    return scan.receival_lot_id || null;
  }),
);

export const selectPenScanLotIdByWeighLotScanId = createSelector(
  [getWeighLotScans, selectScanByWeighLotScanIdLookup],
  createLookupCombiner((weighLotScan, scanByWeighLotScanIdLookup) => {
    const scan = scanByWeighLotScanIdLookup[weighLotScan.id] || {};
    return scan.pen_scan_lot_id || null;
  }),
);

export const selectSaleLotIdByWeighLotScanId = createSelector(
  [getWeighLotScans, selectScanByWeighLotScanIdLookup],
  createLookupCombiner((weighLotScan, scanByWeighLotScanIdLookup) => {
    const scan = scanByWeighLotScanIdLookup[weighLotScan.id] || {};
    return scan.sale_lot_id || null;
  }),
);
